// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Lg74x","productName":"Table_productName__1mfAP"};